import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { Toaster } from 'react-hot-toast';

import { keycloak } from 'src/lib/keycloak';
import { client } from 'src/lib/apollo';
import App from 'src/App.tsx'

import { TOAST_OPTIONS } from './constants';
import './index.css'
import "./i18n"

// const authLink = setContext((_, { headers }) => {
//   const token = keycloak?.token;
//   return {
//     headers: {
//       ...headers,
//       authorization: token ? `Bearer ${token}` : "",
//     }
//   }
// });

const initOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
  checkLoginIframeInterval: 0,
  silentCheckSsoFallback: false,
  enableLogging: true,
  pkceMethod: 'S256',
};


createRoot(document.getElementById('root')!).render(
  <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
  <ApolloProvider client={client}>
      <App />
      <Toaster 
       toastOptions={TOAST_OPTIONS}
      />
  </ApolloProvider>
  </ReactKeycloakProvider>
)
